import { Injectable } from "@angular/core";
import {
  CanActivate,
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
  Router,
} from "@angular/router";
import { Observable } from "rxjs";
import { SharedService } from "../../../shared/services/shared.service";
import { TokenService } from "../../tokenManagement/token.service";

//users home guard
@Injectable()
export class UsersGuard implements CanActivate {
  perms = this.shared.permissions;
  constructor(
    private shared: SharedService,
    private router: Router,
    private token: TokenService
  ) {
    this.shared.activatePermmisions();
  }

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean> | Promise<boolean> | boolean {
    let isPermitted: boolean = false;
    if (this.perms.ROLE_MANAGEMENT) {
      isPermitted = true;
    } else {
      // this.token.clearStorage();
      this.router.navigate(["/auth"]);
      // location.reload();
      return isPermitted;
    }
    return isPermitted;
  }
}

//role guard
// @Injectable()
// export class RoleGuard implements CanActivate {
//   perms = this.shared.permissions;
//   constructor(private shared: SharedService, private router: Router) {
//     this.shared.activatePermmisions();
//   }

//   canActivate(
//     next: ActivatedRouteSnapshot,
//     state: RouterStateSnapshot
//   ): Observable<boolean> | Promise<boolean> | boolean {
//     let isPermitted: boolean = false;
//     if (this.perms.ROLE_MANAGEMENT) {
//       isPermitted = true;
//     } else {
//       this.router.navigate(["/auth"]);
//       return isPermitted;
//     }
//     return isPermitted;
//   }
// }
